import React, { FunctionComponent } from 'react';
import styles from './icon-with-text-section.module.scss';
import { SpaceBetweenColumnsType } from '../../typings';
import { Text, ITextProps } from '../text/text';
import classNames from 'classnames/bind';
import { marginBetweenItemsClasses } from '../../utils/utils';

export interface IIconWithTextSectionProps {
  icon: {
    url: string;
    description: string;
  };
  header: ITextProps[];
  description: ITextProps[];
  displayOption: number;
  marginBetweenItems: SpaceBetweenColumnsType;
  iconPosition: string;
}

const cx = classNames.bind(styles);

export const IconWithTextSection: FunctionComponent<IIconWithTextSectionProps> = ({
  icon,
  header,
  description,
  displayOption,
  marginBetweenItems,
  iconPosition
}) => {
  const gridClass = cx(marginBetweenItemsClasses(marginBetweenItems));

  return (
    <div className={`${styles.wrapper} ${gridClass}`}>
      <div
        className={styles.iconWrapper}
        style={{
          gridColumn: `${displayOption} / ${displayOption}`,
          alignItems: iconPosition
        }}
      >
        <img className={styles.icon} src={icon.url} alt={icon.description} />
      </div>
      <div className={styles.text}>
        {header.length ? (
          <div className={styles.header}>
            {header.map((text: ITextProps, i) => (
              <Text {...text} key={i} />
            ))}
          </div>
        ) : null}
        {description.length ? (
          <div className={styles.description}>
            {description.map((text: ITextProps, i) => (
              <Text {...text} key={i} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
